import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import lodash from 'lodash';
import VerticalLabelList from '../../../../label/VerticalLabelList';
import FieldSet from '../../../../fieldset/FieldSet';
import Grid from '../../../../grid/Grid';
import ObjectUtils from '../../../../../modules/ObjectUtils';
import { EMPTY_GRID_DEFAULT_MESSAGE, } from '../../../../../modules/Constants';

class GRParkingDetailedCitation extends React.Component {
  constructor(props) {
    super(props);
    const { citation = {}, } = this.props;
    const headers = [];
    const rows = [];
    const payments = ObjectUtils.formatStringAsJSONArray(citation.payments);
    if (payments.length > 0) {
      const proto = payments[0];
      Object.keys(proto).forEach((key) => {
        headers.push({
          value: key,
          display: lodash.startCase(key),
        });
      });
      payments.forEach((payment) => {
        rows.push({
          value: Object.values(payment),
          raw: payment,
        });
      });
    }
    this.state = {
      paymentHeaders: headers,
      paymentRows: rows,
    };
  }

  static exclusions = [ 'className', 'mongoId', 'customerIds', 'payments', ];

  render() {
    const { citation, } = this.props;
    const { paymentHeaders, paymentRows, } = this.state;

    const items = VerticalLabelList.toList({
      Id: citation.id,
      Paid: citation.paid,
      'Balance due': citation.balanceDue,
      'Initial Final': citation.initialFine,
      'Issue Date': moment(citation.issueDate)
        .utc()
        .format(),
      'Citation Number': citation.citationNumber,
      'License Plate': citation.licensePlate,
      'First Penalty Date': moment(citation.firstPenaltyDate)
        .utc()
        .format(),
      'Second Penalty Date': moment(citation.secondPenaltyDate)
        .utc()
        .format(),
      'Fine At First Penalty Date': citation.fineAtFirstPenaltyDate,
      'Fine At Second Penalty Date': citation.fineAtSecondPenaltyDate,
      'Handwritten Citation': citation.handWrittenCitation,
      'Disposition Type': citation.dispositionType,
      'Disposition Date': moment(citation.dispositionDate)
        .utc()
        .format(),
      Violation: citation.violation,
    });

    return (
      <div>
        <FieldSet title="Citation Summary" style={{ maxHeight: '300px', }}>
          <VerticalLabelList items={items} exclusions={this.exclusions} />
        </FieldSet>
        <div style={{ marginTop: '20px', }}>
          <FieldSet title="Payments">
            <Grid
              headers={paymentHeaders}
              rows={paymentRows}
              onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
            />
          </FieldSet>
        </div>
      </div>
    );
  }
}

GRParkingDetailedCitation.propTypes = {
  citation: PropTypes.instanceOf(Object).isRequired,
};

export default GRParkingDetailedCitation;
